import { useAuth } from '@/contexts/AuthContext';

/**
 * 🚀 ОПТИМИЗАЦИЯ: Убран дублирующий RPC-вызов is_super_admin
 * Роль уже проверяется в AuthContext (systemRole)
 * Теперь используем данные из useAuth напрямую
 */
export const useSuperAdmin = () => {
  const { systemRole, loading } = useAuth();
  
  // Super admin определяется по роли из AuthContext
  const isSuperAdmin = systemRole === 'super_admin' || systemRole === 'platform_owner';

  return { isSuperAdmin, loading };
};